export interface RemoveEmptyFieldsOptions {
  deep?: boolean;
}

export const removeEmptyFields = <T extends object>(
  object: T,
  options: RemoveEmptyFieldsOptions = { deep: true }
): T => {
  const isNonEmpty = (value: unknown): boolean =>
    value != null &&
    (typeof value !== 'string' || value.trim() !== '') &&
    (!Array.isArray(value) || value.length > 0) &&
    (typeof value !== 'object' || Object.keys(value).length > 0);

  const removeEmptyProps = (obj: object): object => {
    return Object.entries(obj).reduce(
      (result, [key, value]) => {
        if (isNonEmpty(value)) {
          result[key] =
            options.deep && typeof value === 'object' && !Array.isArray(value)
              ? removeEmptyProps(value)
              : value;
        }
        return result;
      },
      {} as Record<string | number | symbol, unknown>
    );
  };

  return removeEmptyProps(object) as T;
};
